module.exports = __webpack_public_path__ + "static/media/sofortLight.9c40fd9d.svg";